import {Component} from "react";
import * as React from "react";
import {Checkbox} from "office-ui-fabric-react";

export interface SelectableCardProps
{
    className?: string;
    title: string;
    selected: boolean;
    onClick(): void;
}

interface SelectableCardState
{
}

export default class SelectableCard extends Component<SelectableCardProps,SelectableCardState>
{

    constructor(props: Readonly<SelectableCardProps>) {
        super(props);

        this.state = {
        }
    }

    public componentDidMount() {
    }


    public render() {
        return (
            <div className={`card card--thin card--padded card--margin-small flex-row ${this.props.className ? this.props.className : ""}`} key={this.props.title} onClick={this.props.onClick}>
                <div className={"flex-row flex-item--flex-1"}>
                    <span className={"flex-item--flex-1"}>{this.props.title}</span>
                    {this.props.selected ? <Checkbox checked={true}/> : null}
                </div>
                {this.props.children}
            </div>
        );
    }
}